import { getV2ApiCompanyIdCardsIncreaseLimitsStatus } from 'src/client/spendesk-api';

export type GetCardLimitsIncreaseStatusInput = {
  companyId: string;
};

export type CardLimitsStatus = {
  status: 'approved' | 'rejected' | null;
  requesterName?: string;
  requestDate?: string;
};

export const getCardLimitsIncreaseStatus = async ({
  companyId,
}: GetCardLimitsIncreaseStatusInput): Promise<CardLimitsStatus> => {
  const response = await getV2ApiCompanyIdCardsIncreaseLimitsStatus({
    path: {
      companyId,
    },
  });
  if (response.statusCode !== 200) {
    throw new Error('Failed to retrieve card limits increase status.');
  }

  return response.body.data;
};
